export enum KIND {
  PRIMARY = 1,
  SECONDARY,
}
